import React from 'react';
import {_GPY} from './env.js'

class RightLinks extends React.Component {

  render () {
		return (
        <div>
            <a target="_blank" rel="noopener noreferrer" href="https://www.guppyi.com/datenschutz/">{_GPY.i18n.get('register_from_agb_data_protection_link_data_protection')}</a> | <a target="_blank" rel="noopener noreferrer" href="https://www.guppyi.com/agb/">{_GPY.i18n.get('register_from_agb_data_protection_link_agb')}</a>  | <a target="_blank" rel="noopener noreferrer" href="http://bugtracking.guppyi.de">Bugtracker</a> 
        </div>)
  }
}
export default RightLinks;
